import React, { useState } from 'react';
import styles from './step2.module.scss';
import classNames from 'classnames/bind';
import { CommonCard } from '../../common/card';
import { CommonButton } from '../../common/button';
import { InterviewPracticeStepCode } from '@domain/constant/interviewPracticeStep';
import useInterviewPracticeStore from '@stores/InterviewStore/InterviewPracticeStore';
import { shallow } from 'zustand/shallow';
import Button from '@components/common/button';
import Text from '@components/common/text';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';

const cx = classNames.bind(styles);

export const Step2 = () => {
  const toNextStep = useInterviewPracticeStore((state) => state.practiceStepInfo.toNextStep, shallow);
  const setStep = useInterviewPracticeStore((state) => state.practiceStepInfo.setStep, shallow);
  const [movingNext, setMovingNext] = useState(false);

  const handleClickPrevious = () => {
    setStep(InterviewPracticeStepCode.GUIDE_STEP1);
  };

  const handleClickNext = () => {
    setMovingNext(true);
    setTimeout(() => toNextStep(), 500);
  };

  return (
    <CommonCard className={cx('card', { movingNext })}>
      <Text fontStyle={FontStyle.H4_B} styles={{ textAlign: 'center', marginBottom: 24 }}>
        20초 이상 답변을 해야
        <br />
        제출이 가능합니다.
      </Text>
      <div className={cx('image')} />
      <div className={cx('footer')}>
        <Button theme="secondary" onClick={handleClickPrevious} styles={{ width: 168, height: 48 }}>
          이전
        </Button>
        <Button onClick={handleClickNext} styles={{ width: 168, height: 48 }}>
          확인 완료
        </Button>
      </div>
    </CommonCard>
  );
};
